import { InjectionToken, Type } from '@angular/core';

// This defines the shape: A map where each value is a function returning a Promise of a Component
export type ComponentLoaderMap = Record<string, () => Promise<Type<any>>>;

export const COMPONENT_REGISTRY = new InjectionToken<ComponentLoaderMap>('COMPONENT_REGISTRY');
